<div class="container">
  <div class="row">
    <div class="col-6 flex">
      <div class="panel flex-grow">
        <button
          mat-mini-fab
          ngClass="button-edit"
          (click)="onEditClick('customer')"
          *ngIf="
            route.snapshot.queryParams['view'] !== 'refund' && route.snapshot.queryParams['view'] !== 'completeAuth'
          "
        >
          <mat-icon fontSet="fa" fontIcon="fa-pen" />
        </button>
        <div class="panel__title">Customer Details</div>
        <div class="panel__content">
          <dl class="dl-table container">
            <div class="row">
              <dt class="col-4"><span>Customer name:</span></dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.companyName
                    : form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.onetimepay
                    ? form?.getRawValue()?.payment?.oneTimePaymentMethod?.customerName ?? '-'
                    : form?.getRawValue()?.customer?.companyName ?? '-'
                }}</span>
              </dd>
            </div>
            <div class="row">
              <dt class="col-4">
                <span>
                  {{
                    form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.onetimepay
                      ? 'Customer Reference Number'
                      : 'Account number'
                  }}
                </span>
              </dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.companyAccountNumber
                    : form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.onetimepay
                    ? form?.getRawValue()?.payment?.oneTimePaymentMethod?.customerReferenceNumber ?? '-'
                    : form?.getRawValue()?.customer?.companyAccountNumber ?? '-'
                }}</span>
              </dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Email address:</span></dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.contactEmail
                    : form?.getRawValue()?.customer?.contactEmail ?? '-'
                }}</span>
              </dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Last name:</span></dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.contactLastName
                    : form?.getRawValue()?.customer?.contactLastName ?? '-'
                }}</span>
              </dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>First name:</span></dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.contactFirstName
                    : form?.getRawValue()?.customer?.contactFirstName ?? '-'
                }}</span>
              </dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Business phone:</span></dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.contactPhoneNumber
                    : form?.getRawValue()?.customer?.contactPhoneNumber ?? '-'
                }}</span>
              </dd>
            </div>
            <div class="row">
              <dt class="col-4"><span>Mobile phone:</span></dt>
              <dd class="col-8">
                <span>{{
                  route.snapshot.queryParams['view'] === 'adjust' ||
                  route.snapshot.queryParams['view'] === 'refund' ||
                  route.snapshot.queryParams['view'] === 'completeAuth'
                    ? transactionDetails?.customerDetails?.mobilePhoneNumber
                    : form?.getRawValue()?.customer?.mobilePhoneNumber ?? '-'
                }}</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="panel">
              <button
                mat-mini-fab
                ngClass="button-edit"
                (click)="onEditClick('payment')"
                *ngIf="
                  route.snapshot.queryParams['view'] !== 'adjust' &&
                  route.snapshot.queryParams['view'] !== 'refund' &&
                  route.snapshot.queryParams['view'] !== 'completeAuth'
                "
              >
                <mat-icon fontSet="fa" fontIcon="fa-pen" />
              </button>
              <div class="panel__title">Payment Details</div>
              <div class="panel__content">
                <div class="container">
                  <div class="row">
                    <div class="col-6">
                      <dl class="dl-table container">
                        <div class="row">
                          <dt class="col-7">
                            <span>{{
                              form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.flashpay
                                ? 'Payment type:'
                                : form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.achpay
                                ? 'Payment type:'
                                : form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.onetimepay
                                ? 'Payment type:'
                                : 'Card type:'
                            }}</span>
                          </dt>
                          <dd class="col-5">
                            <span style="white-space: nowrap">{{
                              form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.flashpay
                                ? 'Flashpay Link'
                                : form?.getRawValue()?.payment?.paymentMode === PaymentMethodMode.onetimepay
                                ? 'One Time Payment'
                                : paymentMethod.accountType
                            }}</span>
                          </dd>
                        </div>

                        <!-- Use if/else to ensure only one section shows -->
                        <ng-container *ngIf="isAchPayment(paymentMethod); else cardPayment">
                          <div class="row">
                            <dt class="col-7"><span>Account Number:</span></dt>
                            <dd class="col-5">
                              <span>{{ paymentMethod.account }}</span>
                            </dd>
                          </div>
                          <div class="row">
                            <dt class="col-7"><span>ABA Route:</span></dt>
                            <dd class="col-5">
                              <span>{{ paymentMethod.abaRoute }}</span>
                            </dd>
                          </div>
                        </ng-container>

                        <ng-template #cardPayment>
                          <div class="row">
                            <dt class="col-7"><span>Card number:</span></dt>
                            <dd class="col-5">
                              <span>{{ getCardAccount(paymentMethod) | ccMask }}</span>
                            </dd>
                          </div>
                          <div class="row">
                            <dt class="col-7"><span>Card expiration:</span></dt>
                            <dd class="col-5">
                              <span>{{
                                getCardExpiration(paymentMethod) | cardExpiration : getCardExpirationOptions()
                              }}</span>
                            </dd>
                          </div>
                        </ng-template>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="panel">
              <button mat-mini-fab ngClass="button-edit" (click)="onEditClick('invoice')">
                <mat-icon fontSet="fa" fontIcon="fa-pen" />
              </button>
              <div class="panel__title">
                {{ isMultiInvoiceMode ? 'Multiple Invoices' : getViewText('title') }}
              </div>
              <div class="panel__content">
                <!-- Single Invoice Summary -->
                <div class="container" *ngIf="!isMultiInvoiceMode">
                  <div class="row">
                    <div class="col-6">
                      <dl class="dl-table container">
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth'">
                          <dt class="col-7"><span>Invoice Number:</span></dt>
                          <ng-container *ngIf="(form?.getRawValue()?.invoice?.invoiceNumber?.length || 0) > 10">
                            <p>&nbsp;</p>
                          </ng-container>
                          <dd class="col-5">
                            <span>{{ form?.getRawValue()?.invoice?.invoiceNumber }}</span>
                          </dd>
                        </div>
                        <div class="row">
                          <dt class="col-7">
                            <span>{{ getViewText('label') }}</span>
                          </dt>
                          <dd class="col-5">
                            <span>{{
                              sanitizeCurrency(form?.getRawValue()?.invoice?.invoiceTotalAmount ?? 0) | currency
                            }}</span>
                          </dd>
                        </div>
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth' && !hideTax">
                          <dt class="col-7"><span>Tax:</span></dt>
                          <dd class="col-5">
                            <span>{{ sanitizeCurrency(form?.getRawValue()?.invoice?.taxAmount ?? 0) | currency }}</span>
                          </dd>
                        </div>
                      </dl>
                    </div>
                    <div class="col-6">
                      <dl class="dl-table container">
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth'">
                          <dt class="col-7"><span>Capital:</span></dt>
                          <dd class="col-5">
                            <span>{{
                              sanitizeCurrency(form?.getRawValue()?.invoice?.capitalAmount ?? 0) | currency
                            }}</span>
                          </dd>
                        </div>
                        <div class="row" *ngIf="route.snapshot.queryParams['view'] !== 'preAuth'">
                          <dt class="col-7"><span>Shipping:</span></dt>
                          <dd class="col-5">
                            <span>{{
                              sanitizeCurrency(form?.getRawValue()?.invoice?.shippingAmount ?? 0) | currency
                            }}</span>
                          </dd>
                        </div>
                        <div class="row">
                          <dt class="col-7">
                            <strong>{{
                              route.snapshot.queryParams['view'] === 'preAuth'
                                ? 'Requested Amount:'
                                : route.snapshot.queryParams['view'] === 'completeAuth'
                                ? 'Total Authorized Amount:'
                                : route.snapshot.queryParams['view'] === 'refund'
                                ? 'Total Refunded Amount:'
                                : route.snapshot.queryParams['view'] === 'adjust'
                                ? 'Total Adjusted Amount:'
                                : 'Payment Total:'
                            }}</strong>
                          </dt>
                          <dd class="col-5">
                            <strong>{{
                              sanitizeCurrency(form?.getRawValue()?.invoice?.totalAmount ?? 0) | currency
                            }}</strong>
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </div>

                <!-- Multi-Invoice Summary -->
                <div class="multi-invoice-summary" *ngIf="isMultiInvoiceMode && multiInvoiceData">
                  <table class="invoice-summary-table">
                    <thead>
                      <tr>
                        <th>Invoice #</th>
                        <th>Outstanding</th>
                        <th>Paying</th>
                        <th *ngIf="hasCredits()">Credit</th>
                        <th>Charged</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of multiInvoiceData.invoices">
                        <td>{{ item.invoice.invoiceNumber }}</td>
                        <td>{{ item.outstandingBalance | currency }}</td>
                        <td>{{ item.paymentAmount | currency }}</td>
                        <td *ngIf="hasCredits()">{{ (item.creditAmount ?? 0) > 0 ? '−' + (item.creditAmount | currency) : '—' }}</td>
                        <td>{{ cashOf(item) | currency }}</td>
                      </tr>
                      <tr *ngIf="(multiInvoiceData.onAccountAmount ?? 0) > 0" class="on-account-row">
                        <td>Applied to account</td>
                        <td>—</td>
                        <td>{{ multiInvoiceData.onAccountAmount | currency }}</td>
                        <td *ngIf="hasCredits()">—</td>
                        <td>{{ multiInvoiceData.onAccountAmount | currency }}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="subtotal-row" *ngIf="hasCredits()">
                        <td [attr.colspan]="summaryColumns() - 1"><strong>Credits applied:</strong></td>
                        <td><strong>−{{ multiInvoiceData.creditsAppliedAmount | currency }}</strong></td>
                      </tr>
                      <tr class="subtotal-row" *ngIf="hasCapitalCost()">
                        <td [attr.colspan]="summaryColumns() - 1"><strong>Subtotal charged:</strong></td>
                        <td><strong>{{ getInvoiceSubtotal() | currency }}</strong></td>
                      </tr>
                      <tr class="capital-cost-row" *ngIf="hasCapitalCost()">
                        <td [attr.colspan]="summaryColumns() - 1">
                          <strong>Capital Cost ({{ multiInvoiceData.capitalCostPercent }}%):</strong>
                        </td>
                        <td>
                          <strong>{{ multiInvoiceData.capitalCostAmount | currency }}</strong>
                        </td>
                      </tr>
                      <tr class="total-row">
                        <td [attr.colspan]="summaryColumns() - 1"><strong>{{ isFlashPay ? 'Total requested:' : 'Total charged:' }}</strong></td>
                        <td>
                          <strong>{{ getTotalAmount() | currency }}</strong>
                        </td>
                      </tr>
                      <tr *ngIf="getTotalAmount() <= 0 && hasCredits()">
                        <td [attr.colspan]="summaryColumns()">Credit covers this payment — nothing will be charged.</td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
